import { z } from 'zod/v4';

/**
 * What a tracing request for one order line would demand of it.
 *
 * Part of the module's contract rather than its internals: the service exposes
 * this, and a caller outside order-hub needs the shape without importing a use
 * case.
 */

export const LineTracingRequirementsParamsSchema = z.object({
  companyId: z.string().min(1),
  orderId: z.string().min(1),
  orderLineId: z.string().min(1),
  /** Overrides the order's, and then the company's, default template. */
  attachmentTemplateId: z.string().min(1).nullish(),
  ruleTemplateId: z.string().min(1).nullish(),
});

export type LineTracingRequirementsParams = z.infer<
  typeof LineTracingRequirementsParamsSchema
>;

export const LineTracingRequirementsSchema = z.object({
  attachmentTemplateId: z.string(),
  /** Every document type the template mentions, mandatory or not. */
  documentTypes: z.array(z.string()),
  /** The subset the template marks mandatory. */
  requiredDocumentTypes: z.array(z.string()),
  /** Mandatory types already uploaded against the line or its order. */
  presentDocumentTypes: z.array(z.string()),
  /** Mandatory types still outstanding — empty means the line is ready. */
  missingDocumentTypes: z.array(z.string()),
});

export type LineTracingRequirements = z.infer<
  typeof LineTracingRequirementsSchema
>;
